<template>
  <div class="mall-info">
    <div class="container">
      <div class="t1 fs-26 lh-34 c-19">{{ $t("商品详情") }}</div>
      <div class="content-box df">
        <div class="left-box df jcc">
          <img
            :src="
              mallInfo.image ||
              'https://img1.baidu.com/it/u=4101939559,1931437443&fm=253&fmt=auto&app=138&f=JPEG?w=1067&h=800'
            "
            alt=""
          />
        </div>
        <div class="right-box">
          <div class="name">{{ mallInfo.name }}</div>
          <!-- 描述 -->
          <div class="desc">{{ mallInfo.description }}</div>

          <div class="df mb-18">
            <span class="s1">{{ $t("参考价格") }}</span>
            <span class="d1">¥{{ mallInfo.price }}</span>
          </div>
          <!-- 兑换积分 -->
          <div class="df mb-18">
            <span class="s1">{{ $t("兑换积分") }}</span>
            <span class="d1">{{ mallInfo.point }}</span>
          </div>
          <!-- 可兑换数量 -->
          <div class="df mb-18">
            <span class="s1">{{ $t("可兑换数量") }}</span>
            <span class="d1">{{
              mallInfo.exchangeLimit || mallInfo.exchangeLimit === 0
                ? mallInfo.exchangeLimit
                : 0
            }}</span
            ><span class="ml-2">{{ $t("次") }}</span>
          </div>
          <!-- 商品总数 -->
          <div class="df mb-18">
            <span class="s1">{{ $t("商品总数") }}</span>
            <span class="d1">{{ mallInfo.tg_total_qty ?? 0 }}</span
            ><span class="ml-2">{{ $t("件") }}</span>
          </div>
          <!-- 人气 -->
          <div
            class="df mb-18"
            v-if="
              mallInfo.popularity !== null && mallInfo.popularity !== undefined
            "
          >
            <span class="s1">{{ $t("人气") }}</span>
            <span class="d1">{{ mallInfo.popularity }}</span>
          </div>
          <!-- 兑换有效期 -->
          <div class="df mb-18">
            <span class="s1">{{ $t("兑换有效期") }}</span>
            <span class="d1">{{ mallInfo.expire }}</span>
          </div>

          <div class="df jcfe mt-42">
            <el-button type="primary" class="btn" @click="handleExchange">{{
              $t("立即兑换")
            }}</el-button>
          </div>
        </div>
      </div>

      <!-- 商品详情 -->
      <div class="malldesc">
        <div class="lh-34 df aic">
          <span class="t1 c-19 fs-20">{{ $t("商品说明") }}</span>
        </div>

        <div class="desc" v-if="safeDescHtml" v-html="safeDescHtml"></div>
        <div class="no-data pt-60" v-else>
          <img :src="require('@/assets/images/empty_data.png')" alt="" />
          <p>{{ $t("暂无数据") }}</p>
        </div>
        <div class="mt-40">
          <span class="t1 c-19 fs-20">{{ $t("兑换说明") }}</span>
        </div>
        <div
          class="desc"
          v-if="safeInstructionsHtml"
          v-html="safeInstructionsHtml"
        ></div>
        <div class="no-data pt-60" v-else>
          <img :src="require('@/assets/images/empty_data.png')" alt="" />
          <p>{{ $t("暂无数据") }}</p>
        </div>
      </div>
    </div>

    <!-- 兑换失败弹窗 -->
    <el-dialog
      :title="$t('兑换失败')"
      :visible.sync="dialogVisible"
      width="374px"
      custom-class="exchange-dialog"
    >
      <div class="fs-14 c-19 lh-22">
        {{ dialogMessage || $t("当前积分不足，无法兑换该商品") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="dialogVisible = false">{{
          $t("我知道了")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {
  getGoodsDetail,
  getGoodsInstructions,
  exchangeValidate,
} from "@/api/pointmall";
import { getLoginInfo } from "@/api/common";
export default {
  name: "PointMallInfo",
  data() {
    return {
      mallInfo: {
        id: null,
        name: "",
        price: null,
        stock: null,
        inventory: null,
        exchangeLimit: 0,
        description: "",
        image: "",
        point: null,
        popularity: null,
        expire: "",
        desc: "",
        exchangeDesc: "",
        status: null,
        dataStatus: null,
        notExchangeTips: "",
        // 兑换校验相关
        can_exchange_window: 0,
        can_exchange_by_user: 0,
        currentPoint: null,
      },
      safeDescHtml: "",
      instructionsContent: "",
      safeInstructionsHtml: "",
      safeExchangeHtml: "",
      dialogVisible: false,
      dialogMessage: "",
    };
  },
  created() {
    this.fetchDetail();
    this.fetchInstructions();
  },
  methods: {
    async handleExchange() {
      // 后端统一校验（登录/积分/库存/时间窗口）
      try {
        const id = this.mallInfo.id;
        if (!id) return;
        const st = Number(this.mallInfo.status ?? 10);
        const ds = Number(this.mallInfo.dataStatus ?? 10);
        if (ds === 20 || st === 20) {
          this.dialogMessage =
            this.mallInfo.notExchangeTips || this.$t("当前不可兑换");
          this.dialogVisible = true;
          return;
        }
        const res = await exchangeValidate({ tg_id: Number(id), quantity: 1 });

        if (res && (res.code === 200 || res.status === 200)) {
          // 校验通过，进入兑换页
          this.$router.push({
            name: "POINTMALL_EXCHANGE",
            params: { id: this.mallInfo.id },
          });
          return;
        }

        const status = Number(res && res.status ? res.status : 0);
        const msg = res && res.msg;

        // 统一拦截器已弹提示的情况（例如 201），本地不再重复弹出
        if (status === 201) {
          return;
        }

        // 未登录
        if (status === 401) {
          this.$message.warning(this.$t("请先登录"));
          this.$jumpLogin();
          return;
        }
        // 时间窗口/库存/积分不足/商品不存在等 4022/422/404：统一弹窗
        if (status === 4022 || status === 422 || status === 404) {
          this.dialogMessage = msg;
          this.dialogVisible = true;
          return;
        }
      } catch (e) {
        this.$message.error(this.$t("网络异常，请稍后重试"));
      }
    },
    async fetchDetail() {
      try {
        const id = this.$route.params.id;
        if (!id) return;
        const res = await getGoodsDetail({ tg_id: Number(id) });
        if (
          res &&
          (res.code === 200 || res.status === 200) &&
          res.data &&
          res.data.goods
        ) {
          const g = res.data.goods;
          this.mallInfo = {
            id: g.tg_id || Number(id),
            name: g.tg_name || "",
            price: g.tg_ref_price || null,
            stock: null,
            inventory: g.tg_available_qty || null,
            tg_total_qty: g.tg_total_qty || null,
            description: g.tg_specs || "",
            image: g.tg_main_image_attr || "",
            point: g.tg_points || null,
            popularity: g.tg_hits || null,
            expire: g.tg_end_time
              ? `${dayjs.unix(g.tg_end_time).format("YYYY-MM-DD")}`
              : "",
            desc: g.tg_desc || "",
            exchangeDesc: g.tg_content || "",
            status: g.tg_status ?? 10,
            dataStatus: g.tg_data_status ?? 10,
            notExchangeTips: g.tg_not_exchange_tips || "",
            // 兑换校验相关
            can_exchange_window: g.can_exchange_window ?? 0,
            can_exchange_by_user: res.data.can_exchange_by_user ?? 0,
            currentPoint: res.data.user_now_score ?? null,
          };
          const perUserCap = Number(g.tg_available_qty || 0);
          if (typeof res.data.user_exchange_limit === "number") {
            this.mallInfo.exchangeLimit = res.data.user_exchange_limit;
          } else {
            this.mallInfo.exchangeLimit = perUserCap;
          }
          this.safeDescHtml = this.normalizeHtml(
            this.mallInfo.desc || this.mallInfo.exchangeDesc || ""
          );
          this.safeExchangeHtml = this.normalizeHtml(
            this.mallInfo.exchangeDesc
          );
        }
      } catch (e) {
        console.error("获取商品详情失败", e);
      }
    },
    async fetchInstructions() {
      try {
        const res = await getGoodsInstructions();
        if (res && res.status === 200 && res.data) {
          const data = res.data;
          // 后端返回为空数组或对象，统一兜底处理
          this.instructionsContent = data.tgi_content || "";
          this.safeInstructionsHtml = this.normalizeHtml(
              this.instructionsContent
          );
        }
      } catch (e) {
        console.error("获取兑换说明失败", e);
      }
    },
    decodeHtml(val) {
      const s = val == null ? "" : String(val);
      if (!s) return "";
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(s, "text/html");
        return doc && doc.body ? doc.body.innerHTML : s;
      } catch (e) {
        return s;
      }
    },
    sanitizeHtml(html) {
      const s = html == null ? "" : String(html);
      if (!s) return "";
      const tmp = document.createElement("div");
      tmp.innerHTML = s;
      const nodes = tmp.querySelectorAll("script,style");
      nodes.forEach((n) => n.parentNode && n.parentNode.removeChild(n));
      return tmp.innerHTML;
    },
    normalizeHtml(val) {
      const raw = this.decodeHtml(val);
      const tmp = document.createElement("div");
      tmp.innerHTML = raw;
      const imgs = tmp.querySelectorAll("img");
      imgs.forEach((img) => {
        const src = img.getAttribute("src") || "";
        if (!src) return;
        if (/^https?:\/\//i.test(src)) return;
        if (src.startsWith("/")) return;
        if (src.startsWith("storage/")) img.setAttribute("src", "/" + src);
      });
      const nodes = tmp.querySelectorAll("script,style");
      nodes.forEach((n) => n.parentNode && n.parentNode.removeChild(n));
      return tmp.innerHTML;
    },
  },
};
</script>

<style lang="scss" scoped>
.malldesc {
  margin-top: 60px;

  .desc {
    color: rgba(25, 25, 25, 1);
    font-family: "harmonyos";
    font-size: 14px;
    font-weight: 500;
    line-height: 26px;
    margin-top: 20px;
  }

  .t1 {
    font-family: "MicrosoftYaHeiSemibold";
  }
}

::v-deep() {
  .exchange-dialog {
    .el-dialog__header .el-dialog__title {
      padding-left: 30px;
      font-size: 14px;
      color: #191919;
    }

    &.el-dialog {
      border-radius: 8px !important;
    }

    .el-dialog__body {
      padding: 0 24px;
    }

    .el-dialog__footer {
      padding: 22px;
    }

    .el-dialog__header {
      padding: 24px;
    }

    .el-dialog__header .el-dialog__title::after {
      width: 24px;
      background: transparent !important;
      content: "\e8e7";
      color: #e02128;
      font-size: 22px;
      font-family: "iconfont" !important;
    }
  }
}

.content-box {
  margin-top: 40px;

  .left-box {
    width: 44%;
    max-width: 100%;
    max-height: 100%;
  }

  .right-box {
    width: calc(56% - 24px);
    margin-left: 24px;
    min-height: 464px;
    border-radius: 4px;
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.08);
    background: rgba(255, 255, 255, 1);
    overflow: hidden;
    padding: 40px;

    .btn {
      border: none;
      outline: none;
      min-width: 140px;
      height: 48px;
      border-radius: 40px;
      font-size: 16px;
      color: #ffffff;
      padding: 0 24px;
    }

    .name {
      color: rgba(25, 25, 25, 1);
      font-size: 24px;
      font-weight: 700;
      line-height: 36px;
    }

    .desc {
      color: rgba(25, 25, 25, 1);
      // font-family: "harmonyos";
      font-size: 16px;
      line-height: 24px;
      margin-top: 12px;
      margin-bottom: 30px;
    }

    .s1 {
      min-width: 100px;
      padding-right: 12px;
      color: #333;
      font-size: 17px;
      line-height: 24px;
    }

    .d1 {
      font-family: "MicrosoftYaHeiSemibold";
      color: #191919;
      font-size: 18px;
      line-height: 24px;
    }
  }
}

.mall-info {
  padding: 84px 80px 60px;
  background: #f9f9f9;

  .container {
    max-width: 1400px;
    margin: 0 auto;
    border-radius: 8px;
    background: rgba(255, 255, 255, 1);
    padding: 24px 40px 120px;

    .t1 {
      font-weight: 500;
      font-family: "harmonyos";
    }
  }
}
</style>
